import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@src/store/store'
import { UserStateType } from './reducer'

export const selectUser = (state: RootState): UserStateType => state.user
export const selectUserInfo = (state: RootState) => selectUser(state).user
export const selectUserListAddresses = (state: RootState) => selectUser(state).listAddresses
export const selectUserIsLoadingListAddresses = (state: RootState) => selectUser(state).isLoadingListAddresses
export const selectUserCurrentAddresses = createSelector(
  [selectUserListAddresses, selectUser],
  (addresses, state) => addresses.find((item) => item.accountId === state.currentAddresses),
)
export const selectUserIsLoadingChangePhones = (state: RootState) => selectUser(state).isLoadingChangePhone
export const selectIsLoadingChangePhoneNotification = (state: RootState) => selectUser(state).isLoadingChangePhoneNotification
export const selectUserIsSuccessChangePhone = (state: RootState) => selectUser(state).isSuccessChangePhone
export const selectUserServices = (state: RootState) => selectUser(state).services
export const selectUserSumToPay = (state: RootState) => selectUser(state).sumToPay
export const selectUserSalary = (state: RootState) => selectUser(state).salary
export const selectUserLastPayment = (state: RootState) => selectUser(state).lastPayment
export const selectIsSuccessTerminationAgreements = (state: RootState) => selectUser(state).isSuccessTerminationAgreements
export const selectSubscriptionsIsSuccessGameForm = (state: RootState) => selectUser(state).isSuccessGameForm
export const selectTerminationCauses = (state: RootState) => selectUser(state).terminationCauses
export const selectMessagesForUser = (state: RootState) => selectUser(state).messagesForUsers
export const selectUserUnreadMessages = (state: RootState) => selectUser(state).userUnreadMessages
export const selectUserId = (state: RootState) => selectUser(state).userId
